import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { SettingsScreen } from './pages/SettingsScreen';

// /settings is a standard authenticated route: requires a session
// (ProtectedRoute) and the user must have finished onboarding
// (OnboardingCompletionGuard bounces incomplete users back to
// /onboarding/personal-details). Matches the dashboard pattern.
export const settingsRoutes = (
  <Route
    path="/settings"
    element={
      <ProtectedRoute>
        <OnboardingCompletionGuard>
          <SettingsScreen />
        </OnboardingCompletionGuard>
      </ProtectedRoute>
    }
  />
);
